/* istanbul ignore file */
export { default } from './DatePicker';
